const API_URL =
  process.env.REACT_APP_API_URL ||
  process.env.VITE_API_URL ||
  "https://ecovanta.onrender.com";

function getToken() {
  return (
    localStorage.getItem("token") ||
    localStorage.getItem("ecovanta_token") ||
    ""
  );
}

function authHeaders() {
  const token = getToken();

  return token
    ? {
        Authorization: `Bearer ${token}`,
      }
    : {};
}

async function parseResponse(response, fallbackMessage) {
  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(data.error || data.message || fallbackMessage);
  }

  return data;
}

export async function getEvidence(filters = {}) {
  const params = new URLSearchParams();

  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && String(value).trim() !== "") {
      params.append(key, value);
    }
  });

  const queryString = params.toString();

  const response = await fetch(
    `${API_URL}/evidence${queryString ? `?${queryString}` : ""}`,
    {
      headers: {
        ...authHeaders(),
      },
    }
  );

  return parseResponse(response, "Failed to fetch evidence");
}

export async function getEvidenceSummary() {
  const response = await fetch(`${API_URL}/evidence/summary`, {
    headers: {
      ...authHeaders(),
    },
  });

  return parseResponse(response, "Failed to fetch evidence summary");
}

export async function getEvidenceById(evidenceId) {
  const response = await fetch(`${API_URL}/evidence/${evidenceId}`, {
    headers: {
      ...authHeaders(),
    },
  });

  return parseResponse(response, "Failed to fetch evidence");
}

export async function updateEvidence(evidenceId, payload) {
  const response = await fetch(`${API_URL}/evidence/${evidenceId}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      ...authHeaders(),
    },
    body: JSON.stringify(payload),
  });

  return parseResponse(response, "Failed to update evidence");
}

export async function approveEvidence(evidenceId, reviewComments = "") {
  const response = await fetch(`${API_URL}/evidence/${evidenceId}/approve`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeaders(),
    },
    body: JSON.stringify({ reviewComments }),
  });

  return parseResponse(response, "Failed to approve evidence");
}

export async function rejectEvidence(evidenceId, reviewComments = "") {
  const response = await fetch(`${API_URL}/evidence/${evidenceId}/reject`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeaders(),
    },
    body: JSON.stringify({ reviewComments }),
  });

  return parseResponse(response, "Failed to reject evidence");
}

export async function deleteEvidence(evidenceId) {
  const response = await fetch(`${API_URL}/evidence/${evidenceId}`, {
    method: "DELETE",
    headers: {
      ...authHeaders(),
    },
  });

  return parseResponse(response, "Failed to delete evidence");
}